import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { ScrollIntoView, Alert } from '@grandvisionhq/common';
import { Divider } from '@grandvisionhq/elements';
import { getFilteredQuantityDiscounts, QuantityDiscountSelect, ContactLensesRxInfoModal, divideEvenlyInTwo, getHighestMatchedDiscount } from '@grandvisionhq/fun-products';
import { Helpers } from '@grandvisionhq/inventory';
import { withIntl } from '@grandvisionhq/state';
import { PrescriptionInfo } from './components/PrescriptionInfo/PrescriptionInfo.js';
import { getPriceForPack } from './helpers/get-price-for-pack.js';
import MonthlyPrice from './components/MonthlyPrice/MonthlyPriceContainer.js';
import PackageQuantity from './components/PackageQuantity/PackageQuantityContainer.js';
import Prescription from './components/Prescription/PrescriptionContainer.js';
import { pushSelectBoxQuantity } from '../../../../DataLayer/contact-lens-data-layer.js';

class ConfigureContactLenses extends React.Component {
    componentDidMount() {
        if (this.props.packageTypes[0]) {
            this.setInitialPackSize(this.props.packageTypes[0]);
        }
        this.setInitialSelectedDiscountItem();
    }
    showErrorAlert() {
        const { intl , formValidations  } = this.props;
        return /*#__PURE__*/ React.createElement(ScrollIntoView, {
            key: formValidations.errorCount
        }, /*#__PURE__*/ React.createElement(Alert, {
            type: "error",
            icon: "alert-circle"
        }, intl.getFormattedLabel('products.contactLenses.prescription.text', {
            parseLink: true
        })));
    }
    render() {
        var ref, ref1;
        const { attributes , formValidations , variantData , packageTypes , isCLBBTabSelected , quantityDiscountItems ,  } = this.props;
        const { leftEyeChecked , leftEyeBoxQuantity , leftEyeBoxAvailableQuantity , rightEyeChecked , rightEyeBoxQuantity , rightEyeBoxAvailableQuantity , packSize ,  } = this.state;
        const shouldShowPrescriptionInfoError = formValidations.showError && !formValidations.isPrescriptionInfoValid && (formValidations.isConfiguratorValid ? 'scrollToError' : 'showError') || undefined;
        const filteredQuantityDiscountItemList = getFilteredQuantityDiscounts({
            leftEyeChecked: this.state.leftEyeChecked,
            rightEyeChecked: this.state.rightEyeChecked,
            quantityDiscountItems: this.props.quantityDiscountItems,
            maxOrderableQuantity: this.props.maxOrderableQuantity
        });
        return /*#__PURE__*/ React.createElement("div", {
            className: "contact-lens-configurator"
        }, /*#__PURE__*/ React.createElement(React.Fragment, null, isCLBBTabSelected ? /*#__PURE__*/ React.createElement(MonthlyPrice, null) : /*#__PURE__*/ React.createElement(PackageQuantity, {
            onChange: this.handlePackSizeChange,
            selectedSize: `${this.state.packSize}`,
            packageTypes: packageTypes
        }), quantityDiscountItems && !isCLBBTabSelected && /*#__PURE__*/ React.createElement("div", {
            className: "contact-lens-configurator__quantity-discounts"
        }, /*#__PURE__*/ React.createElement(QuantityDiscountSelect, {
            price: ((ref = this.state.packPrice) === null || ref === void 0 ? void 0 : (ref1 = ref.value) === null || ref1 === void 0 ? void 0 : ref1.centAmount) || 0,
            items: filteredQuantityDiscountItemList,
            selectedValue: this.state.selectedQuantityDiscountValue,
            onChange: (selectedDiscount)=>this.handleUserSelectedQuantityDiscount(selectedDiscount)
            ,
            currency: this.props.intl.currency
        })), /*#__PURE__*/ React.createElement("div", {
            className: "contact-lens-configurator__error-message"
        }, formValidations.showError && !formValidations.isConfiguratorValid && this.showErrorAlert()), /*#__PURE__*/ React.createElement("div", {
            className: "contact-lens-configurator__prescription"
        }, /*#__PURE__*/ React.createElement(Prescription, {
            isCLBBTabSelected: isCLBBTabSelected,
            isActive: rightEyeChecked,
            id: "right",
            onSelection: this.handleRightEyeChecked,
            quantity: rightEyeBoxQuantity,
            availableQuantity: rightEyeBoxAvailableQuantity,
            attributes: attributes,
            products: variantData,
            packSize: packSize,
            onFoundProduct: this.handleRightEyeProductSelection,
            onQuantityChange: this.handleRightEyeQuantity,
            "data-t": "prescription-right-eye",
            className: "contact-lens-configurator__prescription-column",
            hasError: formValidations.showError
        }), /*#__PURE__*/ React.createElement(Divider, {
            orientation: "vertical",
            theme: "light",
            className: "contact-lens-configurator__divider"
        }), /*#__PURE__*/ React.createElement(Prescription, {
            isCLBBTabSelected: isCLBBTabSelected,
            isActive: leftEyeChecked,
            id: "left",
            onSelection: this.handleLeftEyeChecked,
            quantity: leftEyeBoxQuantity,
            availableQuantity: leftEyeBoxAvailableQuantity,
            attributes: attributes,
            products: variantData,
            packSize: packSize,
            onFoundProduct: this.handleLeftEyeProductSelection,
            onQuantityChange: this.handleLeftEyeQuantity,
            "data-t": "prescription-left-eye",
            className: "contact-lens-configurator__prescription-column",
            hasError: formValidations.showError
        })), /*#__PURE__*/ React.createElement(ContactLensesRxInfoModal, {
            className: "contact-lens-configurator__prescription-link"
        }), /*#__PURE__*/ React.createElement(PrescriptionInfo, {
            onChange: this.handlePrescriptionInfoChange,
            shouldShowError: shouldShowPrescriptionInfoError,
            errorCount: formValidations.errorCount
        })));
    }
    constructor(...args){
        super(...args);
        this.state = {
            selectedVariants: {},
            leftEyeChecked: true,
            leftEyeBoxQuantity: 1,
            rightEyeChecked: true,
            rightEyeBoxQuantity: 1,
            packSize: 0
        };
        this.setInitialPackSize = ({ packageQuantity  })=>{
            packageQuantity && this.handlePackSizeChange(packageQuantity);
        };
        this.handleChange = (key, value)=>{
            const { handleFormChange  } = this.props;
            this.setState((prevState)=>swcHelpers.objectSpread({}, prevState, {
                    [key]: value
                })
            , ()=>handleFormChange && handleFormChange(this.state)
            );
        };
        this.handleLeftEyeChecked = (selection)=>{
            this.handleDiscountLogicOnSideChecked(selection, 'left');
            this.handleChange('leftEyeChecked', selection);
        };
        this.handleRightEyeChecked = (selection)=>{
            this.handleDiscountLogicOnSideChecked(selection, 'right');
            this.handleChange('rightEyeChecked', selection);
        };
        this.handleLeftEyeQuantity = (quantity)=>{
            this.handleDiscountLogicOnQuantityChange(quantity, 'left');
            this.handleChange('leftEyeBoxQuantity', quantity);
        };
        this.handleRightEyeQuantity = (quantity)=>{
            this.handleDiscountLogicOnQuantityChange(quantity, 'right');
            this.handleChange('rightEyeBoxQuantity', quantity);
        };
        /**
   * This function is used to handle the discount logic when the quantity of the box is changed
   * [@param](https://github.com/param) {number} quantity - The updated quantity.
   * [@param](https://github.com/param) {'right' | 'left'} side - The eye side being updated.
   */ this.handleDiscountLogicOnQuantityChange = (quantity, side)=>{
            let totalQuantity = quantity;
            if (this.state.leftEyeChecked && side === 'right') {
                totalQuantity += this.state.leftEyeBoxQuantity;
            }
            if (this.state.rightEyeChecked && side === 'left') {
                totalQuantity += this.state.rightEyeBoxQuantity;
            }
            this.findAndSetSelectedDiscountItem(totalQuantity);
        };
        /**
   * This function is used to handle the discount logic on component load
   */ this.setInitialSelectedDiscountItem = ()=>{
            let totalQuantity = 0;
            if (this.state.leftEyeChecked) {
                totalQuantity += this.state.leftEyeBoxQuantity;
            }
            if (this.state.rightEyeChecked) {
                totalQuantity += this.state.rightEyeBoxQuantity;
            }
            this.findAndSetSelectedDiscountItem(totalQuantity);
        };
        /**
   * This function is used to handle the discount logic when the side is checked
   * [@param](https://github.com/param) {boolean} selected - Whether the side is selected.
   * [@param](https://github.com/param) {'right' | 'left'} side - The eye side being updated.
   */ this.handleDiscountLogicOnSideChecked = (selected, side)=>{
            let totalQuantity = 0;
            const leftEyeChecked = selected && side === 'left' || side === 'right' && this.state.leftEyeChecked;
            const rightEyeChecked = selected && side === 'right' || side === 'left' && this.state.rightEyeChecked;
            if (leftEyeChecked) {
                totalQuantity += this.state.leftEyeBoxQuantity;
            }
            if (rightEyeChecked) {
                totalQuantity += this.state.rightEyeBoxQuantity;
            }
            this.findAndSetSelectedDiscountItem(totalQuantity, leftEyeChecked, rightEyeChecked);
        };
        /**
   * This function is used to handle the quantity discount item change.
   * [@param](https://github.com/param) {number} discountItemValue - The value of the selected discount item.
   */ this.handleUserSelectedQuantityDiscount = (selectedDiscount)=>{
            const defaultDiscountItemValue = 2;
            const bothEyesChecked = this.state.leftEyeChecked && this.state.rightEyeChecked;
            if (bothEyesChecked) {
                const [boxQuantityLeft, boxQuantityRight] = divideEvenlyInTwo((selectedDiscount === null || selectedDiscount === void 0 ? void 0 : selectedDiscount.quantity) || defaultDiscountItemValue);
                this.handleChange('leftEyeBoxQuantity', boxQuantityLeft);
                this.handleChange('rightEyeBoxQuantity', boxQuantityRight);
            } else if (this.state.leftEyeChecked) {
                this.handleChange('leftEyeBoxQuantity', (selectedDiscount === null || selectedDiscount === void 0 ? void 0 : selectedDiscount.quantity) || defaultDiscountItemValue);
            } else if (this.state.rightEyeChecked) {
                this.handleChange('rightEyeBoxQuantity', (selectedDiscount === null || selectedDiscount === void 0 ? void 0 : selectedDiscount.quantity) || defaultDiscountItemValue);
            }
            /* The quantity discount can be selected in different ways:
      1. by User - when selecting or deselecting the QuantityDiscountSelect tile
      2. by lens configuration - when quantity for either left or right lens is adjusted
      */ /* User has selected quantity discount */ if (selectedDiscount !== undefined) {
                this.findAndSetSelectedDiscountItem(selectedDiscount.quantity, this.state.leftEyeChecked, this.state.rightEyeChecked, selectedDiscount);
            } else {
                /* User has deselected quantity discount */ this.findAndSetSelectedDiscountItem(defaultDiscountItemValue, this.state.leftEyeChecked, this.state.rightEyeChecked);
            }
        };
        this.findAndSetSelectedDiscountItem = (quantity, leftEyeChecked, rightEyeChecked, discountSelectedByUser)=>{
            const matchedDiscount = getHighestMatchedDiscount(quantity, {
                leftEyeChecked: leftEyeChecked !== undefined ? leftEyeChecked : this.state.leftEyeChecked,
                rightEyeChecked: rightEyeChecked !== undefined ? rightEyeChecked : this.state.rightEyeChecked,
                quantityDiscountItems: this.props.quantityDiscountItems,
                maxOrderableQuantity: this.props.maxOrderableQuantity
            });
            this.handleChange('selectedQuantityDiscountValue', matchedDiscount === null || matchedDiscount === void 0 ? void 0 : matchedDiscount.discount.minimumQuantity);
            if (matchedDiscount !== undefined) {
                /* if there is a matched discount ... */ if (discountSelectedByUser !== undefined) {
                    /* ... and it is selected by User,
        then keep the selected discount quantity and pricing as the user selected */ this.handleChange('selectedQuantityDiscount', {
                        item: matchedDiscount === null || matchedDiscount === void 0 ? void 0 : matchedDiscount.discount,
                        prices: discountSelectedByUser,
                        selectionType: 'user'
                    });
                } else {
                    this.handleChange('selectedQuantityDiscount', {
                        item: matchedDiscount === null || matchedDiscount === void 0 ? void 0 : matchedDiscount.discount,
                        prices: undefined,
                        selectionType: 'configurator'
                    });
                }
            } else {
                this.handleChange('selectedQuantityDiscount', undefined);
            }
        };
        this.handlePackSizeChange = (packSize)=>{
            var ref;
            let newPackSize;
            switch(typeof packSize){
                case 'string':
                    newPackSize = parseInt(packSize);
                    break;
                case 'number':
                    newPackSize = packSize;
                    break;
                case 'object':
                    newPackSize = +packSize.value;
                    break;
                default:
                    return;
            }
            this.setState({
                packPrice: getPriceForPack(newPackSize, this.props.packageTypes)
            }, ()=>this.handleChange('packSize', newPackSize)
            );
            this.state.packPrice && pushSelectBoxQuantity((ref = this.state.packPrice) === null || ref === void 0 ? void 0 : ref.value, this.state.dailiesUsageLevel, `${this.state.packSize}`);
        };
        this.handleProductSelection = (side, product)=>{
            this.setState({
                selectedVariants: swcHelpers.objectSpread({}, this.state.selectedVariants, {
                    [side]: product
                })
            });
            const skuKey = side === 'left' ? 'leftEyeBoxSKU' : 'rightEyeBoxSKU';
            const SKU = product && product.sku;
            this.handleChange(skuKey, SKU);
            const availableQuantityKey = side === 'left' ? 'leftEyeBoxAvailableQuantity' : 'rightEyeBoxAvailableQuantity';
            const availableQuantity = product && Helpers.getAvailableQuantity(product.availability);
            this.handleChange(availableQuantityKey, availableQuantity);
        };
        this.handleLeftEyeProductSelection = this.handleProductSelection.bind(this, 'left');
        this.handleRightEyeProductSelection = this.handleProductSelection.bind(this, 'right');
        this.handlePrescriptionInfoChange = (prescriptionState)=>{
            this.handleChange('prescriptionInfo', prescriptionState);
        };
    }
}
var ConfigureContactLenses$1 = withIntl(ConfigureContactLenses);

export { ConfigureContactLenses, ConfigureContactLenses$1 as default };
//# sourceMappingURL=ConfigureContactLenses.js.map
